export default "__VITE_ASSET__iG$JT8u$__"